import React from "react";
import { NavLink } from "react-router-dom";
import { ButtonMenu, ButtonMenuItem } from "@edricphan2022/uikit";
import { Heading } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import styled from "styled-components";
import { useMatchBreakpoints } from "@edricphan2022/uikit";
import { Box } from "@edricphan2022/uikit";

const Wrapper = styled.div`
  .cus-overflow {
    overflow: auto;
    ::-webkit-scrollbar-thumb {
      display: none;
      background-color: transparent;
    }
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }

  }
  .Services-tab-group {
    width: fit-content;
    margin: auto;
    position: relative;
    :after{
      width: 100%;
      height: 3px;
      background-color: #cbcbcb;
      content: '';
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: -1;
    }
  }
  .cus-mint {
    min-width: 307px;
    border-radius: 0px;
    border: none;
    box-shadow: none;
  }
  .active{
    border-bottom: 5px solid #333333
  }
`;

const TabActive = ({ activeIndex = 0 }: { activeIndex?: number }) => {
  const { isTabletS } = useMatchBreakpoints();

  return (
    <Wrapper>
      <Text className="cus-overflow" textAlign="center">
        <Box className="Services-tab-group">
          <ButtonMenu activeIndex={activeIndex} variant="subtle">
            <ButtonMenuItem
              className={`cus-mint ${activeIndex === 0 ? "active" : ""}`}
              id="swap-nav-link"
              to="/services/web&dev"
              as={NavLink}
            >
              <Heading scale={isTabletS ? "sm" : "lg"}>
                Website Design & Development
              </Heading>
            </ButtonMenuItem>
            <ButtonMenuItem
              className={`cus-mint ${activeIndex !== 0 ? "active" : ""}`}
              id="pool-nav-link"
              to="/services/blockchain-tecnology"
              as={NavLink}
            >
              <Heading scale={isTabletS ? "sm" : "lg"}>
                Mobile app development
              </Heading>
            </ButtonMenuItem>
          </ButtonMenu>
        </Box>
      </Text>
    </Wrapper>
  );
};

export default TabActive;
